import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

// import { createPopper } from '@popperjs/core';
// will use for button and tooltip auto postion
// removed linked form index.hrml file and added from npm

const rootElement = document.getElementById("root");

// Check if the root has child nodes (prerendered content)
if (rootElement.hasChildNodes()) {
  // Hydrate the prerendered content
  hydrateRoot(
    rootElement,
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
} else {
  // Regular client-side render
  const root = createRoot(rootElement);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
